// Story cover art — 1:1 port of design/Cover.dc.html: pastel gradient h → h+26° (160°),
// crescent moon, three stars, two translucent hills. Generated on the client: zero requests.

export const coverColors = (hue: number) => ({
  c1: `hsl(${hue} 92% 88%)`,
  c2: `hsl(${(hue + 26) % 360} 72% 75%)`,
});

export const COVER_ART = [
  { d: 'M70 17A13 13 0 1 0 79 38A14 14 0 0 1 70 17Z', o: 0.92 },
  { d: 'M30 17Q30 22 35 22Q30 22 30 27Q30 22 25 22Q30 22 30 17Z', o: 0.9 },
  { d: 'M46 9Q46 12 49 12Q46 12 46 15Q46 12 43 12Q46 12 46 9Z', o: 0.8 },
  { d: 'M0 76Q24 62 50 72T100 68V100H0Z', o: 0.32 },
  { d: 'M0 88Q30 75 60 85T100 82V100H0Z', o: 0.55 },
] as const;
export const COVER_DOT = { cx: 20, cy: 37, r: 1.4, o: 0.8 } as const;

/** Square PNG data URL of a cover, for the lock screen (Media Session artwork). */
export async function coverPng(hue: number, size = 512): Promise<string | null> {
  const { c1, c2 } = coverColors(hue);
  // 160° CSS gradient ≈ from top-left-ish to bottom-right-ish in a square.
  const art = COVER_ART.map((p) => `<path d="${p.d}" fill="#fff" fill-opacity="${p.o}"/>`).join('');
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 100 100">` +
    `<defs><linearGradient id="g" x1="0.33" y1="0" x2="0.67" y2="1">` +
    `<stop offset="0" stop-color="${c1}"/><stop offset="1" stop-color="${c2}"/></linearGradient></defs>` +
    `<rect width="100" height="100" fill="url(#g)"/>${art}` +
    `<circle cx="${COVER_DOT.cx}" cy="${COVER_DOT.cy}" r="${COVER_DOT.r}" fill="#fff" fill-opacity="${COVER_DOT.o}"/></svg>`;
  try {
    const img = new Image();
    img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
    await img.decode();
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = size;
    canvas.getContext('2d')?.drawImage(img, 0, 0, size, size);
    return canvas.toDataURL('image/png');
  } catch {
    return null;
  }
}
